// extracted by mini-css-extract-plugin
export default {"treatment":"_treatment_Ib8duB","treatment-items":"_treatment-items_QxzwTT","suggestions-dropdown":"_suggestions-dropdown_mvlY8Y"};